import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '@/context/AuthContext'
import type { UserRole } from '@/domain/roles'
import { LoadingSpinner } from './LoadingSpinner'

interface ProtectedRouteProps {
  children: ReactNode
  // P2: when provided, only these roles may render the route — anyone else
  // is redirected to their own Dashboard rather than seeing a 404, since the
  // route exists, it's just not part of their role's experience (Document 2
  // §3 role boundaries).
  allowedRoles?: UserRole[]
}

export function ProtectedRoute({ children, allowedRoles }: ProtectedRouteProps) {
  const { currentUser, isLoading } = useAuth()

  if (isLoading) return <LoadingSpinner label="Checking your session…" />
  if (!currentUser) return <Navigate to="/login" replace />
  if (allowedRoles && !allowedRoles.includes(currentUser.role)) {
    return <Navigate to="/dashboard" replace />
  }

  return <>{children}</>
}
